import { createFileRoute } from '@tanstack/react-router'
import { messagesSearchSchema } from '@/features/messages/model'
import { MessagesScreen } from '@/features/messages/routes/messages-screen'

export const Route = createFileRoute('/messages')({
  // ?with=<contact> opens a conversation; the group and search live here too.
  validateSearch: messagesSearchSchema,
  component: MessagesPage,
})

function MessagesPage() {
  return <MessagesScreen search={Route.useSearch()} />
}
